var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.processedData),function(queue){return _c('p',[_vm._v(_vm._s(queue.name)+": "+_vm._s(queue.count))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }